import request from '@/config/axios'

export interface HomeEditorVO {
	content: string
}

// 查询homeEditor
export const getHomeEditor = async () => {
	return await request.get<HomeEditorVO>({ url: '/manage/homeEditor/get'})
}